module.exports = __webpack_public_path__ + "static/media/yongfu_liao.425f05cb.jpg";